<template>
  <figure class="browser">
    <div class="browser-bar" aria-hidden="true">
      <i></i><i></i><i></i><span>{{ label }}</span>
    </div>
    <img
      :src="src"
      :srcset="srcset"
      :sizes="srcset ? sizes : null"
      :alt="alt"
      width="2160"
      height="1350"
      loading="lazy"
      decoding="async"
    />
  </figure>
</template>

<script>
export default {
  name: "BrowserFrame",
  props: {
    src: { type: String, required: true },
    label: { type: String, required: true },
    alt: { type: String, default: "" },
    srcset: { type: String, default: null },
    sizes: { type: String, default: "100vw" },
  },
};
</script>
